import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withFetch,
} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { YamlTranslateLoader } from './yaml-translate-loader';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { authInterceptor } from './interceptors/auth.interceptor';
import { IMAGE_CONFIG } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AngularYandexMapsModule } from 'angular8-yandex-maps';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from '../environments/environment';
import { provideClientHydration } from '@angular/platform-browser';

// Фабрика для создания экземпляра TranslateHttpLoader
export function HttpLoaderFactory(http: HttpClient) {
  return new YamlTranslateLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
        disableImageLazyLoadWarning: true,
      },
    },
    { provide: MAT_DATE_LOCALE, useValue: 'ru-RU' },
    provideNativeDateAdapter(),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideAnimationsAsync(),
    importProvidersFrom(TooltipModule.forRoot()),
    importProvidersFrom(
      AngularYandexMapsModule.forRoot({
        apikey: 'YANDEX_API_KEY',
      })
    ),
    importProvidersFrom(RecaptchaV3Module),
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.captchaSiteKey },
    provideClientHydration(),
  ],
};
